import { Carousel } from 'react-bootstrap';
import './NewLoginCarousel.scss'; // Import your custom CSS file
import { Box } from '@mui/material';
import { getS3FLIconLink } from '../../../../../util/utility';

function NewLoginCarousel() {
    return (
        <Box
            sx={{
                border: '1px solid #5980F8',
                padding: '1.5rem',
                position: 'relative',
                minHeight: '370px',
                minWidth: '550px',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: {
                        xs: '-2px',
                        lg: '-4px',
                    },
                    left: {
                        xs: '-72px',
                        lg: '-89px',
                    },
                    width: {
                        xs: '6rem',
                        lg: '7.5rem',
                    },
                    height: {
                        xs: '6rem',
                        lg: '7.5rem',
                    },
                }}
            >
                <img
                    src={'/assets/squarensemicircle.svg'}
                    width={'100%'}
                    height={'100%'}
                    alt={'uneven-img'}
                />
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    bottom: {
                        xs: '-2px',
                        lg: '-3px',
                    },
                    right: {
                        xs: '-105px',
                        lg: '-145px',
                    },
                    width: {
                        xs: '8rem',
                        lg: '11rem',
                    },
                    height: {
                        xs: '8rem',
                        lg: '11rem',
                    },
                }}
            >
                <img
                    src="/assets/uneven-shape.svg"
                    width={'100%'}
                    height={'100%'}
                    alt={'uneven-img'}
                />
            </Box>

            <Carousel className="login-carousel">
                <Carousel.Item interval={2500}>
                    <div>
                        <img
                            src={getS3FLIconLink('wellversed-founder', 'svg')}
                            width={'100%'}
                            height={'100%'}
                            alt={'wellversed-founder'}
                        />
                    </div>
                </Carousel.Item>
                <Carousel.Item interval={2500}>
                    <div>
                        <img
                            src={getS3FLIconLink('moveinsync-founder', 'svg')}
                            width={'100%'}
                            height={'100%'}
                            alt={'moveinsync-founder'}
                        />
                    </div>
                </Carousel.Item>
                <Carousel.Item interval={2500}>
                    <div>
                        <img
                            src={getS3FLIconLink('freightify-founder', 'svg')}
                            width={'100%'}
                            height={'100%'}
                            alt={'freightify-founder'}
                        />
                    </div>
                </Carousel.Item>
            </Carousel>
        </Box>
    );
}

export default NewLoginCarousel;
